<template>
  <div class="login">
    <h1 class="logo">登录</h1>
    <div class="content">
      <div class="form">
        <div class="input-item">
          <input type="text" v-model="username" placeholder="请输入用户名">
        </div>
        <div class="input-item">
          <input type="password" v-model="password" placeholder="请输入密码" >
        </div>
        <div class="second">
          <span class="forget">忘记密码</span>
        </div>
        <div class="sub-btn" @click="login">登 录</div>
      </div>
      <div class="cut"></div>
      <div class="right">
        <div class="des">
          <span>没有账号？</span>
          <span class="register" @click="register">立即注册</span>
        </div>
        <!--<div class="other">-->
          <!--使用其他方式登录-->
          <!--<div>-->
            <!--<i class="fa fa-qq"></i>-->
            <!--<i class="fa fa-weixin"></i>-->
          <!--</div>-->
        <!--</div>-->
      </div>
    </div>

  </div>
</template>

<script>

  export default {
    data() {
      return {
        username: '',
        password: ''
      }
    },
    methods: {
      login(){
        const self = this;
        if(this.global._PROJECT=='shdq'){
          if(self.username!='volvo'&&self.username!='ba'&&self.username!='test'&&self.username!='admin'){
            self.$message.error('用户名或密码错误');
            return;
          }
        }
        this.$http({
          method: 'post',
          url: (self.$route.query.app?('/apps/'+self.$route.query.app):'')+'/iapi/user/login/',
          data: self.qs.stringify({'username':self.username,'password':self.password}),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          }
        }).then(function (response) {
          if(response.data.code!=0){
            self.$message.error(response.data.message);
            return;
          }
          self.$message.success('登录成功');
          if(self.$route.query.next)
            window.location = self.$route.query.next
        },error=>{
          this.$message.error('用户名或密码错误')
        })
      },
      enterEvent(e){
        if(e.keyCode==13){
          this.login();
        }
      },
      register(){
          const self = this;
          if(this.global._PROJECT=='shdq'){
            // self.$message.error('已禁用');
            return;
          }
          this.$router.push({name:'Register',query:self.$route.query});
      },
    },
    created(){
      document.addEventListener('keyup', this.enterEvent);
    },
    destroyed(){
      document.removeEventListener('keyup', this.enterEvent);
    }
  }
</script>

<style scoped>
  .login {
    position: absolute;
    width: 700px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: -50px;
  }

  .logo {
    text-align: left;
    margin-bottom: 20px;
    margin-left: 10px;
    font-size: 44px;
    color: #fff;
  }

  .content {
    border: 1px solid #dce1e6;
    border-radius: 2px;
    background: #fff;
    padding: 80px 60px;
    text-align: left;
  }

  .form {
    width: 300px;
    display: inline-block;
  }

  .input-item {
    width: 100%;
    margin-bottom: 10px;
  }

  .input-item input {
    border: 0;
    border-bottom: 1px solid #ededed;
    width: 100%;
    height: 44px;
    box-shadow: none;
    font-size: 14px;
    padding-left: 10px;
    color: #333;
    outline: none;
  }

  .second {
    text-align: right;
    font-size: 14px;
    color: #00b38a;
    margin: 20px 0;
  }

  .forget {
    cursor: pointer;
  }

  .sub-btn {
    line-height: 45px;
    height: 45px;
    text-align: center;
    color: #fff;
    background: #00b38a;
    cursor: pointer;
  }

  .cut {
    width: 1px;
    background: #ededed;
    height: 200px;
    display: inline-block;
    margin: 0 30px;
    position: relative;
    color: #ededed;
  }

  .cut:after {
    position: absolute;
    content: 'or';
    left: 50%;
    top: 50%;
    padding: 2px;
    transform: translate(-50%, -50%);
    background: #fff;
  }

  .right {
    float: right;
    width: 200px;
    font-size: 14px;
    height: 230px;
    position: relative;
    text-align: center;
  }

  .register {
    color: #00b38a;
    cursor: pointer;
  }

  .des {
    margin-top: 100px;
    margin-bottom: 20px;
  }

  .other {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
  }

  .other i {
    margin-right: 10px;
    cursor: pointer;
  }
  @media screen and (max-width: 414px){
    .login{
      width: 100%;
      top:0;
      left: 0;
      bottom:0;
      transform: translate(0,0);
      margin-top: 0;
    }
    .logo{
      margin-top: 10px;
      margin-bottom: 10px;
      font-size: 32px;
    }
    .content{
      border: 0;
      text-align: center;
      padding:80px 0;
    }
    .cut{
      display: none;
    }
    .right{
      float: none;
      width: 100%;
      height: 200px;
    }
    .des{
      margin-top: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pass/Login.vue